import { Brain, BarChart3, Settings2, Trophy, Users } from 'lucide-react';

export const features = [
  {
    icon: Brain,
    title: "Innovative AI Solutions",
    description: "We focus on creating AI-driven business solutions that revolutionize how businesses interact with data."
  },
  {
    icon: BarChart3,
    title: "Expertise in Data Analytics",
    description: "With a team of data science professionals and experience across industries, we provide the best business intelligence solutions."
  },
  {
    icon: Settings2,
    title: "Tailored Data Solutions",
    description: "Our approach is centered on delivering custom data analytics services that meet the specific needs of each business."
  },
  {
    icon: Trophy,
    title: "Proven Track Record",
    description: "From cloud-based machine learning data solutions to predictive analytics in e-commerce, our solutions consistently deliver results."
  },
  {
    icon: Users,
    title: "Customer-Focused Approach",
    description: "We work closely with our clients to ensure that the AI technologies we provide are aligned with their business goals."
  }
];
